import React from 'react';

import styled from '@emotion/styled';

import { tableFormatDateNG } from '../../utils/utils';

interface CompanySearchCardProps {
  data: any;
}
const CompanySearchCard: React.FC<CompanySearchCardProps> = ({ data }) => {
  console.log('CompanySearchCard data:', data?.industryType);
  return (
    <Container>
      <Img
        src={data.profilePicture ?? '/static/img/profilePlaceholder2.png'}
        alt='Rider Avatar'
      />
      <DescriptionArea>
        <CompanyName>{data.name}</CompanyName>
        <About>{data.industryType}</About>
        <Info>
          <span>On platform since:</span>
          <Time>{tableFormatDateNG(data.createdAt)}</Time>
        </Info>
      </DescriptionArea>
    </Container>
  );
};

export default CompanySearchCard;

const Container = styled.div`
  display: grid;
  grid-template-columns: 60px auto;
  align-items: center;
  gap: 32px;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
`;

const Img = styled.img`
  width: 60px;
  height: 60px;
  /* border-radius: 8px; */
`;

const DescriptionArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  font-weight: 600;
  /* border: 1px solid red; */
`;

const CompanyName = styled.div`
  font-weight: 600;
  line-height: 18px;
  color: ${({ theme }) => theme.palette.logirateBlack};
`;

const About = styled.div`
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-weight: 14px;
  font-size: 14px;
`;

const Info = styled.div`
  display: flex;
  gap: 8px;
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-size: 14px;
  font-weight: 400;
`;

const Time = styled.div`
  color: ${({ theme }) => theme.palette.grayTextColor};
  font-weight: 600;
`;
